// Prop types are not to be included in our production builds. When the consuming
// application sets NODE_ENV to production, instead of exporting the prop types,
// we export mock functions. This ensures no errors are thrown, but does no
// validation and saves a few bytes.
const designTokenPropTypes = process.env.NODE_ENV === 'production' ? require('./prop-types/mocks.js').default : require('./prop-types/index.js').default;
export { designTokenPropTypes };
export { loadDesignTokens } from './load.js';

// Defaults populated as part of the build
// eslint-disable-next-line
export const defaults = require('./defaults.json');